export default __webpack_public_path__ + "static/media/userprofile.64828db7.svg";